import Actions from '../../../constants/Actions';
import BillingStore from '../../../stores/BillingStore';
import TransactionTypes from '../../../constants/TransactionTypes';

export async function loadSubscriptionPage(context) {
  await Promise.all([
    context.executeAction(loadCostTier, {}),
    context.executeAction(loadSubscriptionInformation, {})
  ]);
}

export async function loadSubscriptionInformation(context) {
  const { data: subscription } = await context.service.read('billing', { type: 'subscription' });

  context.dispatch(Actions.BILLING__SUBSCRIPTION_LOADED, subscription);
}

export async function loadCostTier(context) {
  const {data: costTier} = await context.service.read('billing', {type: 'costTier'});

  context.dispatch(Actions.BILLING__COST_TIER_LOADED, costTier);
}

export async function guideCountIncreased(context) {
  context.dispatch(Actions.BILLING__GUIDE_COUNT_UPDATED, true);
}

export async function guideCountDecreased(context) {
  context.dispatch(Actions.BILLING__GUIDE_COUNT_UPDATED, false);
}

export async function paymentTermChanged(context, term) {
  context.dispatch(Actions.BILLING__PAYMENT_TERM_UPDATED, term);
}

export async function supportPackageChanged(context, supportPackage) {
  context.dispatch(Actions.BILLING__SUPPORT_PACKAGE_UPDATED, supportPackage);
}

export async function billingRequestSubmitted(context, {agentName, authorization}) {
  context.dispatch(Actions.BILLING__SUBMIT_REQUEST_STARTED, {});
  const billingStore = context.getStore(BillingStore);
  const selections = billingStore.getSelections();

  try {
    await context.service.create('billing', {}, {
      type: TransactionTypes.subscriptionRequest,
      selections,
      agentName,
      authorization
    });
  } catch (err) {
    context.dispatch(Actions.BILLING__SUBMIT_REQUEST_FAILED, err);
  }

  context.dispatch(Actions.BILLING__SUBMIT_REQUEST_COMPLETED);
}

export function BILLING__REQUEST_SUBMIT_STARTED(context) {
  context.dispatch(Actions.BILLING__REQUEST_STARTED);
}

export function billingRequestCancelled(context) {
  context.dispatch(Actions.BILLING__REQUEST_CANCELLED);
}

export async function loadTransactionHistory(context) {
  const { data: transactions } = await context.service.read('billing', {
    type: 'transactionHistory'
  });

  context.dispatch(Actions.BILLING__TRANSACTION_HISTORY_LOADED, transactions);

  return transactions;
}

export function postTransaction(/* context, payment */) {

}



// WEBPACK FOOTER //
// ./src/apps/Billing/actions/BillingActionCreators.js